var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 534,
    viewBox: "0 0 328 534",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2738_493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.939 197.551V0.333496L0.263672 271.943L163.939 197.551Z",
    fill: "#878A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.939 368.717V197.551L0.263672 271.943L163.939 368.717ZM163.939 197.551L327.645 271.943L163.939 0.333496V197.551Z",
    fill: "#878A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.939 197.551V368.717L327.645 271.943L163.939 197.551Z",
    fill: "#878A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.939 399.712L0.263672 302.999L163.939 533.667V399.712Z",
    fill: "#878A93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.736 302.999L163.939 399.712V533.667L327.736 302.999Z",
    fill: "#878A93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2738_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 534,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthWhite);
export default __webpack_public_path__ + "static/media/eth-white.b364d77659c56e5549ff713b73eefc96.svg";
export { ForwardRef as ReactComponent };